import React, { useState, useEffect, useRef } from 'react';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';
import { FaWhatsapp } from 'react-icons/fa';
import './CaContactSection.css';

// Embedded inline SVG Canada Flag
const CaFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 450"
    style={{ borderRadius: '2px', display: 'inline-block', verticalAlign: 'middle', width: '22px', height: '14px', flexShrink: 0 }}
  >
    <rect width="900" height="450" fill="#fff" />
    <rect width="225" height="450" fill="#D80621" /><rect x="675" width="225" height="450" fill="#D80621" /><polygon fill="#D80621" points="450,75 420,165 330,165 400,215 375,305 450,255 525,305 500,215 570,165 480,165" />


  </svg>
);

const countryList = [
  { name: 'Canada', code: '+1', iso: 'ca' }
];

const CaContactSection = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    course: 'Noorani Qaida',
    phone: '',
    message: ''
  });

  const [selectedCountry, setSelectedCountry] = useState(countryList[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const countryDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitForm('Contact Us Consultation Form', {
        fullName: `${formData.firstName} ${formData.lastName}`.trim(),
        email: 'Not Provided (Contact Form)',
        phone: `${selectedCountry.code} ${formData.phone}`,
        course: formData.course,
        message: formData.message
      });

      Swal.fire({
        title: 'Trial Booked Successfully!',
        text: `Thank you, ${formData.firstName}! Our team will reach out to schedule your free trial session.`,
        icon: 'success',
        confirmButtonColor: '#006100'
      });

      setFormData({
        firstName: '',
        lastName: '',
        course: 'Noorani Qaida',
        phone: '',
        message: ''
      });
      window.location.href = '/thank-you-enrollment-successful/';
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#006100'
      });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredCountries = countryList.filter(
    (c) =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.code.includes(searchQuery)
  );

  return (
    <section className="Ca-contact-section" id="contact">
      <div className="Ca-contact-section__container">
        {/* Top Header Block */}
        <div className="Ca-contact-section__header">
          <h2 className="Ca-contact-section__title">
            Let's Talk About Your Quran Classes Online
          </h2>
          <p className="Ca-contact-section__subtitle">
            Tell us about your learning objectives so that we can associate you with the right tutor. Fill out the form below. Our online Quran classes team reaches out to schedule your free trial sessions.
          </p>
        </div>

        {/* Two Column Grid */}
        <div className="Ca-contact-section__grid">
          {/* Left Column: Form Card */}
          <div className="Ca-contact-card">
            <form onSubmit={handleSubmit} className="Ca-contact-form">
              {/* First Name & Last Name Row */}
              <div className="Ca-contact-form-row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className="Ca-contact-input"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className="Ca-contact-input"
                />
              </div>

              {/* Course Select Dropdown */}
              <div className="Ca-contact-form-group">
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  required
                  className="Ca-contact-select"
                >
                  <option value="Noorani Qaida">Noorani Qaida</option>
                  <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
                  <option value="Quran Reading Classes">Quran Reading Classes</option>
                  <option value="Quran Memorization Classes">Quran Memorization Classes</option>
                  <option value="Quran Translation Classes">Quran Translation Classes</option>
                </select>
              </div>

              {/* Phone Input with US Flag Picker */}
              <div className="Ca-contact-form-group" ref={countryDropdownRef} style={{ position: 'relative' }}>
                <div className="Ca-contact-phone-box">
                  <button
                    type="button"
                    className="Ca-contact-country-btn"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <CaFlag />
                    <span className="Ca-contact-arrow">▲</span>
                    <span className="Ca-contact-code">{selectedCountry.code}</span>
                  </button>
                  <span className="Ca-contact-divider">|</span>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="Ca-contact-phone-input"
                  />
                </div>

                {/* Country Code Dropdown */}
                {isDropdownOpen && (
                  <div className="Ca-contact-country-dropdown">
                    <div className="Ca-contact-search-wrapper">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="Ca-contact-search-input"
                        autoFocus
                      />
                    </div>
                    <ul className="Ca-contact-country-menu">
                      {filteredCountries.map((c) => (
                        <li
                          key={c.name}
                          className={`Ca-contact-country-option ${c.name === selectedCountry.name ? 'Ca-contact-country-option--active' : ''}`}
                          onClick={() => {
                            setSelectedCountry(c);
                            setIsDropdownOpen(false);
                            setSearchQuery('');
                          }}
                        >
                          <span className="Ca-contact-opt-flag">
                            <CaFlag />
                          </span>
                          <span className="Ca-contact-opt-name">{c.name}</span>
                          <span className="Ca-contact-opt-code">{c.code}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Message Field */}
              <div className="Ca-contact-form-group">
                <input
                  type="text"
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="Ca-contact-input"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={submitting}
                className="Ca-contact-submit-btn"
              >
                {submitting ? 'Booking Trial...' : 'Book My Free Trial'}
              </button>
            </form>
          </div>

          {/* Right Column: CONTACT INFO matching screenshot */}
          <div className="Ca-contact-info">
            <h3 className="Ca-contact-info__title">CONTACT INFO</h3>

            <ul className="Ca-contact-info__list">
              {/* Location Item */}
              <li className="Ca-contact-info__item">
                <div className="Ca-contact-info__icon-wrapper">
                  <svg className="Ca-contact-info__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <a href="https://maps.google.com/?q=Mississauga,+Ontario,+L5K,+1W2" target="_blank" rel="noopener noreferrer" className="Ca-contact-info__link">
                  Mississauga, Ontario, L5K, 1W2
                </a>
              </li>


              {/* Phone Ca Item */}
              <li className="Ca-contact-info__item">
                <div className="Ca-contact-info__icon-wrapper">
                  <svg className="Ca-contact-info__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <a href="tel:+16477385707" className="Ca-contact-info__link">
                  +1 647 738 5707 (Ca)
                </a>
              </li>

              {/* Email Item */}
              <li className="Ca-contact-info__item">
                <div className="Ca-contact-info__icon-wrapper">
                  <svg className="Ca-contact-info__icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <a href="mailto:info@alquranlesson.com" className="Ca-contact-info__link">
                  info@alquranlesson.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaContactSection;
